import React, { Component } from 'react';
import Header from '../../Layout/Header'
import { Link } from 'react-router-dom'

import axios from 'axios'
// import ReCAPTCHA  from "react-google-recaptcha"

let api = axios.create({
    baseURL: '/'
});
if (process.env.NODE_ENV === 'development') {
    api = axios.create({
        baseURL: 'http://localhost/'
    });
}




class ContactUs extends Component {

	state = {
		name: "",
		email: "",
		phone: "",
		message: "",
		form: "",
		status: 0,
		recaptcha: "",
		validation: false,
	  }
	
		submitForm = (e) => {
			e.preventDefault();
			window.ga('send', 'event', 'form', 'submit')
			if (this.state.name && this.state.phone) {
				this.setState({ status: 1 })
				var params = new URLSearchParams()
				params.append('name', this.state.name);
				params.append('email', this.state.email);
				params.append('phone', this.state.phone);
				params.append('message', this.state.message);
				api
				  .post('/form.php', params )
					.then(({ data }) => { console.log(data); this.setState({ status: 2 }); this.setState({ form: data }) })
					
					.catch(err => {
						this.setState({ status: 0 })
						this.setState({ validation: true, })
					})
				
				this.setState({ validation: false, })
			} else {
				this.setState({ validation: true, })
		  }
	  }

	render() {
		return (
			<div className="page-contact-us">
				
				<Header
					seoTitle="Contact Us"
					title={<div><i className="fa fa-comment"></i> let's <b>chat!</b></div>}
					image={require('./moshi-bg.jpg')}
				/>
				
				<div className="entry-content">
					<div className="container">
						<div className="row">
							<div className="col-lg-6">
								<h2>
									<div className="line"></div>
									<div className="title">How can we help?</div>
								</h2>
								<div className="tagline">
									We’d love to help your business succeed in the digital era! Please contact us using your preferred method, or complete the form to send us a message.
								</div>
								<h3>Perth and Bunbury</h3>
								<ul>
									<li>Call us <a
										onClick={() => window.ga('send', 'event', 'telephone', 'call')}
										href="tel:0480333393">0480 333 393</a></li>
									<li>Or email <a
										onClick={() => window.ga('send', 'event', 'email', 'send')}
										href="mailto:hello@moshi.com.au">hello@moshi.com.au</a></li>
									
								</ul>
								<p>
								If you’re a talented creative, developer or marketing super-star located between Perth and the South West, we’d love to hear from you for future opportunities.
								</p>
								</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-5">
								{this.state.status === 0 && <form className="messages-holder" onSubmit={this.submitForm}>
									<h3>Please send us a message</h3>

									{this.state.validation ? <label className="alert alert-danger small">Please fill out all the details before submitting.</label> : null}

									<input type="text" placeholder="Name" name="name" onChange={e => this.setState({ name: e.target.value })} />
									<input type="text" placeholder="Email" name="email" onChange={e => this.setState({ email: e.target.value })} />
									<input type="text" placeholder="Phone" name="phone" onChange={e => this.setState({ phone: e.target.value })} />
									<input type="text" placeholder="Company" />
									<textarea type="text"
										rows="6"
										name="message"
										onChange={e => this.setState({ message: e.target.value })}
										placeholder="How can we help" />

									<div className="row">
										<div className="col-lg-6">
											<input type="submit" value="Send Message" />
										</div>
									</div>
								</form>}
								{this.state.status === 1 && <div><h3>Loading Form Submittion...</h3></div>}
         						{this.state.status === 2 && <div><h3>Thank you for your enquiry</h3></div>}
							</div>
						</div>
					</div>
					<Examples />
				</div>
			</div>
		);
	}
}

export const Examples = () =>
<div className="container recent-examples">
<div className="text-center">
	<h2 className="outline">
		<div className="line"></div>
		<div className="title">
			Who we've recently helped
		</div>
	</h2>
</div>
		<div className="row">

		<Example
					to="/what-weve-done/West-Coast-Waste"
					title="West Coast Waste"
				image={require('./WCW.png')} />

<Example
					to="/what-weve-done/hearth-house"
					title="Hearth House"
				image={require('./hearth-house.png')} />

			<Example
					to="/what-weve-done/picton-trailer-hire"
					title="Picton Trailer Hire"
				image={require('./picton.png')} />
			
			<Example
					to="/what-weve-done/harvey-senior-high-school"
					title="Harvey Senior High School"
				image={require('./harvey.png')} />
			
			
			<Example
					to="/what-weve-done/lpc"
					title="LPC"
				image={require('./lpc.png')} />
		<Example
					to="/what-weve-done/bunbury-central"
					title="Bunbury Central"
				image={require('./bunbury-central.png')} />
			
			<Example
					to="/what-weve-done/business-news"
					title="Business News"
				image={require('./business-news.png')} />
			
			<Example
					to="/what-weve-done/koombana-physiotherapy"
					title="Koombana Physiotherapy"
				image={require('./koombana-physiotherapy.png')} />
			
			<Example
					to="/what-weve-done/bunbury-runners-club"
					title="Bunbury Runners Club"
					image={require('./bunbury-runners-club.png')} />
			
			<Example
				to="/what-weve-done/prince-hotel"
				title="Prince Hotel"
				image={require('./prince-hotel.png')} />
			
			<Example
				to="/what-weve-done/van-masters"
				title="Van Masters"
				image={require('./van-masters.png')} />
			
			<Example
				to="/what-weve-done/busfire-front"
				title="Bushfire Front"
				image={require('./bushfire-front.png')} />
			

			<Example
				to="/what-weve-done/dalyellup-property-management"
				title="Dalyellup Property Management"
				image={require('./dalyellup.png')} />
			
			<Example
				to="/what-weve-done/churchview"
				title="Churchview"
				image={require('./churchview.png')} />
			
			<Example
				to="/what-weve-done/cciwa-wa-works"
				title="CCIWA - WA Works"
				image={require('./cciwa.png')} />
			
			<Example
				to="/what-weve-done/harley-dykstra"
				title="Harley Dykstra"
				image={require('./harley-dykstra.png')} />
			
			
			<Example
				to="/what-weve-done/bunbury-turf-club"
				title="Bunbury Turf Club"
				image={require('./bunbury-turf-club.png')} />
			
			<Example
				to="/what-weve-done/enable-wa"
				title="Enable WA"
				image={require('./enable-wa.png')} />
			
			<Example
				to="/what-weve-done/millard"
				title="Millard"
				image={require('./millard.png')} />

			<Example
				to="/what-weve-done/mens-health-wa"
				title="Mens Health and Wellbeing"
				image={require('./mens-health-wa.png')} />

		
</div>
</div>

const Example = ({ title, image, to }) =>
	<div className="col-lg-3 col-md-6">
		<Link to={to ? to : "/"}>
		<div className="example">
			<div
				className="image"
				style={{
					backgroundImage:
						`url(${image})`
				}}></div>
			<div className="details">
				<div>
					<a>View Case Study</a>
				</div>
			</div>
		</div></Link>
	</div>

export default ContactUs;


// WEBPACK FOOTER //
// ./src/Pages/ContactUs/ContactUs.js